<template>
    <div class="summary-details row">
        <div class="col-12">
            <p class="mb-1 text-muted font-12"><currency-display :amount="breakdown.amount" :showCurrencyCode="true" :applyDecimals="true"></currency-display><br> {{ __('messages.colombians_vat_messages') }}</p>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        showBox: false,
        breakdown: {}
    },
    data() {
        return {
            data: {}
        };
    },
    async mounted() {
    }
}
</script>
